const data_CN = {
	topPage: {
		rightImg:require("@/assets/productServices/productOperation/pic_ps.png"),
		englishName:'PRODUCT SERVICE',
		name:'产品运营',
		introText:'Offshore深耕用户，精准营销且精细化运营。服务内容包含：线上线下全渠道运营，包括线上平台店铺（如传统电商平台，各大社交电商，SHEIN，TEMU，Shopee等），线下（实体门店等选址、设施采买、运营指导等）。',
		bottomImg: false
	},
	snakeTimelineInfo: {
		title:'服务1·店站运营',
		subheading:'一站式运营，可根据您的需求提供定制化服务',
		tab1:{
			src: require("@/assets/productServices/productOperation/icon_dianpu.png"),
			title: '成立品牌线上店铺',
			content:['搭建自有官网','OR','助力其他电商','平台上线']
		},
		tab2:{
			src: require("@/assets/productServices/productOperation/icon_sheji.png"),
			title: '品牌导向店铺设计',
			content:['培养创作者','品牌形象管理','视觉设计','店铺装修']
		},
		tab3:{
			src: require("@/assets/productServices/productOperation/icon_goods.png"),
			title: '全域性商品管理',
			content:['商品及价格策略','上市波段','尖货行销','品类及结构','渠道布局及库存管理','爆款打造产品拍摄']
		},
		tab4:{
			src: require("@/assets/productServices/productOperation/icon_yunying.png"),
			title: '内容式流量运营',
			content:['内容策划','媒体渠道拍摄、投放','社交平台流量资源','短视频/直播']
		},tab5:{
			src: require("@/assets/productServices/productOperation/icon_data.png"),
			title: '整合化数据分析',
			content:['销售分析','活动分析及推广分析','行业分析','日常及周期数据分析']
		},
		tab6:{
			src: require("@/assets/productServices/productOperation/icon_store.png"),
			title: '实体门店',
			content:['门店选址','设施采买','运营指导']
		}
	},
	socialPlatformInfo: {
		title: '服务2·社交平台账号运营',
		subtitle: '账号运营服务',
		img: require("@/assets/productServices/productOperation/socialPlatform/pic_koll@2x.png"),
		list: [
			{
				name: ['社交平台','文案编写'],
				img: require("@/assets/productServices/productOperation/socialPlatform/shipinwenantiqu@2x.png")
			},
			{
				name: ['账号代运营'],
				img: require("@/assets/productServices/productOperation/socialPlatform/icon_daiyunying@2x.png")
			},
			{
				name: ['社交平台', '短视频拍摄'],
				img: require("@/assets/productServices/productOperation/socialPlatform/icon_shortvideo@2x.png")
			},
			{
				name: ['账号发展策略'],
				img: require("@/assets/productServices/productOperation/socialPlatform/icon_insight@2x.png")
			},
			{
				name: ['爆款内容打造'],
				img: require("@/assets/productServices/productOperation/socialPlatform/icon_hot@2x.png")
			}
		]
	},
	liveOperationInfo: {
		title: '能力介绍·直播运营',
		subTitle: '全球团队的多文化环境精细化直播运营策略',
		bgImage: require("@/assets/productServices/anchorOperation/channelPlanning/bg_circle@2x.png"),
		all_bg_image: require("@/assets/productServices/anchorOperation/channelPlanning/all_bg_circle@2x.png"),
		list:
		[
			{
				image: require("@/assets/productServices/productOperation/liveOperation/icon_kol@2x.png"),
				title: '直播KOL提供'
			},
			{
				image: require("@/assets/productServices/productOperation/liveOperation/icon_stratgy@2x.png"),
				title: '直播营销策略'
			},
			{
				image: require("@/assets/productServices/productOperation/liveOperation/icon_robot@2x.png"),
				title: '直播Marketing BOT'
			}
		],
		info: {
			title: 'VISION',
			content: '集约模式结合远程人力降低运营人力成本\n共享集团品牌管理资源，保证服务水准'
		},
		image: require("@/assets/productServices/productOperation/liveOperation/pic_coop01.png")
	},
	innovativeTechnology: {
		title: '创新技术',//切图
		subtitle: '创新的技术研发与解决方案',
		list: [
			{
				name: '电商前后端建立',
				info: ['小程序开发', '商城SaaS服务', '员工端管理',' 后台管理'],
				img: require("@/assets/productServices/productOperation/innovativeTechnology/pexels-rodrigo-santos-3888149@2x.png")
			},
			{
				name: '数字营销',
				info: ['数据中台', '数据驾舱', '数据看板'],
				img: require("@/assets/productServices/productOperation/innovativeTechnology/pexels-photo-5632402@2x.png")
			},
			{
				name: '社交平台订阅号',
				img: require("@/assets/productServices/productOperation/innovativeTechnology/pexels-andrea-piacquadio-3760069@2x.png")
			},
			{
				name: '社交营销BOT',
				img: require("@/assets/productServices/productOperation/innovativeTechnology/pexels-pixabay-267350@2x.png")
			}
		]
	}
}

const data_JA = {
	topPage: {
		rightImg:require("@/assets/productServices/productOperation/pic_ps.png"),
		englishName:'PRODUCT SERVICE',
		name:'製品の運営',
		introText:'海外市場での顧客開拓、効果的なマーケティングと精巧な製品運営，オンライン、オフラインの全チャネル運営を含む、トラディショナルな電子商取引プラットフォーム、主要なソーシャル電子商取引プラットフォーム、SHEIN、TEMU、Shopeeなどのオンラインプラットフォーム店、そして実店舗の立地選定、施設の調達、運営指導など',
		bottomImg: false
	},
	snakeTimelineInfo: {
		title:'サービス1.店舗運営',
		subheading:'ワンストップでお客様のニーズに合わせたサービスを提供可能',
		tab1:{
			src: require("@/assets/productServices/productOperation/icon_dianpu.png"),
			title: 'ブランドのオンラインストアを開設する',
			content:['独自の公式ウェブサイトを構築する','また','他の電子商取引プラットフォームのオンライ','ン化を支援する']
		},
		tab2:{
			src: require("@/assets/productServices/productOperation/icon_sheji.png"),
			title: 'ブランド志向の店舗デザイン',
			content:['クリエイターの育成','ブランドイメージの管理','ビジュアルデザイン','店舗工事']
		},
		tab3:{
			src: require("@/assets/productServices/productOperation/icon_goods.png"),
			title: 'グローバル商品管理',
			content:['商品と価格戦略','上市の時間帯','先端的な販売','商品カテゴリーと構造','チャネル構成と在庫管理','人気爆発商品の製作と撮影']
		},
		tab4:{
			src: require("@/assets/productServices/productOperation/icon_yunying.png"),
			title: 'コンテンツトラフィックオペレーション',
			content:['コンテンツ企画','メディアチャンネルでの撮影と公開','ソーシャル プラットフォームのトラフィック リソース ','ショートビデオ/ライブブロードキャスト']
		},tab5:{
			src: require("@/assets/productServices/productOperation/icon_data.png"),
			title: '統合データ分析',
			content:['売上分析','活動分析とプロモーション分析','業界分析','日常的および定期的なデータ分析']
		},
		tab6:{
			src: require("@/assets/productServices/productOperation/icon_store.png"),
			title: '実店舗',
			content:['店の位置','設備調達','操作ガイダンス']
		}
	},
	socialPlatformInfo: {
		title: 'サービス2. ソーシャルプラットフォームアカウント運用',
		subtitle: 'アカウント運用サービス',
		img: require("@/assets/productServices/productOperation/socialPlatform/pic_koll@2x.png"),
		list: [
			{
				name: ['ソーシャルプラットフォーム','向けのコピーライティング'],
				img: require("@/assets/productServices/productOperation/socialPlatform/shipinwenantiqu@2x.png")
			},
			{
				name: ['アカウントエージェントの操作'],
				img: require("@/assets/productServices/productOperation/socialPlatform/icon_daiyunying@2x.png")
			},
			{
				name: ['ソーシャル プラットフォーム', 'での短いビデオ撮影'],
				img: require("@/assets/productServices/productOperation/socialPlatform/icon_shortvideo@2x.png")
			},
			{
				name: ['アカウント開発戦略'],
				img: require("@/assets/productServices/productOperation/socialPlatform/icon_insight@2x.png")
			},
			{
				name: ['爆発的なコンテンツの作成'],
				img: require("@/assets/productServices/productOperation/socialPlatform/icon_hot@2x.png")
			}
		]
	},
	liveOperationInfo: {
		title: '機能紹介 ライブオペレーション',
		subTitle: 'グローバルチームの多文化環境がライブブロードキャスト運営戦略を洗練させる',
		bgImage: require("@/assets/productServices/anchorOperation/channelPlanning/bg_circle@2x.png"),
		all_bg_image: require("@/assets/productServices/anchorOperation/channelPlanning/all_bg_circle@2x.png"),
		list:
		[
			{
				image: require("@/assets/productServices/productOperation/liveOperation/icon_kol@2x.png"),
				title: 'ライブ KOL によって提供される'
			},
			{
				image: require("@/assets/productServices/productOperation/liveOperation/icon_stratgy@2x.png"),
				title: 'ライブマーケティング戦略'
			},
			{
				image: require("@/assets/productServices/productOperation/liveOperation/icon_robot@2x.png"),
				title: 'ライブマーケティングBOT'
			}
		],
		info: {
			title: 'VISION',
			content: '集中モードとリモートの人員を組み合わせて運用の人件費を削減\nグループのブランド経営資源を共有し、サービス水準を確保'
		},
		image: require("@/assets/productServices/productOperation/liveOperation/pic_coop01.png")
	},
	innovativeTechnology: {
		title: '革新的な技術',//切图
		subtitle: '革新的な技術の研究開発とソリューション',
		list: [
			{
				name: 'Eコマースフロントエンド確立',
				info: ['小規模なプログラム開発', 'モールSaaSサービス', '従業員管理','バックステージマネジメント'],
				img: require("@/assets/productServices/productOperation/innovativeTechnology/pexels-rodrigo-santos-3888149@2x.png")
			},
			{
				name: 'デジタルマーケティング',
				info: ['データセンター', 'データコックピット', 'データかんばん'],
				img: require("@/assets/productServices/productOperation/innovativeTechnology/pexels-photo-5632402@2x.png")
			},
			{
				name: 'ソーシャルプラットフォームのサブスクリプション番号',
				img: require("@/assets/productServices/productOperation/innovativeTechnology/pexels-andrea-piacquadio-3760069@2x.png")
			},
			{
				name: 'ソーシャルマーケティングボット',
				img: require("@/assets/productServices/productOperation/innovativeTechnology/pexels-pixabay-267350@2x.png")
			}
		]
	}
}

const data_EN = {
	topPage: {
		rightImg:require("@/assets/productServices/productOperation/pic_ps.png"),
		englishName:'PRODUCT SERVICE',
		name:'Product Operation',
		introText:'Offshore User Cultivation，Precision Marketing，and Sophisticated Operations，including full-channel operations on and offline, including online platform storefronts (such as traditional e-commerce platforms, major social e-commerce platforms, SHEIN, TEMU, Shopee, etc.), and offline ( location selection for physical stores, facility procurement, operational guidance, etc.)',
		bottomImg: false
	},
	snakeTimelineInfo: {
		title:'Service 1. Store operation',
		subheading:'One-stop operation, can provide customized services according to your needs',
		tab1:{
			src: require("@/assets/productServices/productOperation/icon_dianpu.png"),
			title: 'Establish a brand online store',
			content:['Build your own official website','OR','Help other e-commerce','platforms go online']
		},
		tab2:{
			src: require("@/assets/productServices/productOperation/icon_sheji.png"),
			title: 'Brand-oriented store design',
			content:['Cultivate creators','Brand image management','visual design','Store construction']
		},
		tab3:{
			src: require("@/assets/productServices/productOperation/icon_goods.png"),
			title: 'Global Commodity Management',
			content:['Commodity and Price Strategy','listing band','Top-notch marketing','Category and structure','Channel layout and inventory management','Explosive models create product shooting']
		},
		tab4:{
			src: require("@/assets/productServices/productOperation/icon_yunying.png"),
			title: 'Content traffic operation',
			content:['Content planning','Filming and publishing on media channels','Social Platform Traffic Resources','Short video/live broadcast']
		},
		tab5:{
			src: require("@/assets/productServices/productOperation/icon_data.png"),
			title: 'Integrated Data Analysis',
			content:['Sales analysis','Activity analysis and promotion analysis','industry analysis','Daily and periodic data analysis']
		},
		tab6:{
			src: require("@/assets/productServices/productOperation/icon_store.png"),
			title: 'physical store',
			content:['Store location','Facilities procurement','Operation guidance']
		}
	},
	socialPlatformInfo: {
		title: 'Service 2. Social platform account operation',
		subtitle: 'Account Operation Service',
		img: require("@/assets/productServices/productOperation/socialPlatform/pic_koll@2x.png"),
		list: [
			{
				name: ['Copywriting for social platforms',''],
				img: require("@/assets/productServices/productOperation/socialPlatform/shipinwenantiqu@2x.png")
			},
			{
				name: ['Account agent operation'],
				img: require("@/assets/productServices/productOperation/socialPlatform/icon_daiyunying@2x.png")
			},
			{
				name: ['Short video shooting on social platforms', ''],
				img: require("@/assets/productServices/productOperation/socialPlatform/icon_shortvideo@2x.png")
			},
			{
				name: ['Account Development Strategy'],
				img: require("@/assets/productServices/productOperation/socialPlatform/icon_insight@2x.png")
			},
			{
				name: ['Explosive content creation'],
				img: require("@/assets/productServices/productOperation/socialPlatform/icon_hot@2x.png")
			}
		]
	},
	liveOperationInfo: {
		title: 'Capability Introduction Live Operation',
		subTitle: 'The multi-cultural environment of the global team refines the live broadcast operation strategy',
		bgImage: require("@/assets/productServices/anchorOperation/channelPlanning/bg_circle@2x.png"),
		all_bg_image: require("@/assets/productServices/anchorOperation/channelPlanning/all_bg_circle@2x.png"),
		list:
		[
			{
				image: require("@/assets/productServices/productOperation/liveOperation/icon_kol@2x.png"),
				title: 'Provide live KOL'
			},
			{
				image: require("@/assets/productServices/productOperation/liveOperation/icon_stratgy@2x.png"),
				title: 'Live Marketing Strategy'
			},
			{
				image: require("@/assets/productServices/productOperation/liveOperation/icon_robot@2x.png"),
				title: 'Live Marketing BOT'
			}
		],
		info: {
			title: 'VISION',
			content: "Intensive mode combined with remote manpower to reduce operating manpower costs\nShare the Group's brand management resources to ensure service standards"
		},
		image: require("@/assets/productServices/productOperation/liveOperation/pic_coop01.png")
	},
	innovativeTechnology: {
		title: 'Innovative Technology',//切图
		subtitle: 'Innovative technology research and development and solutions',
		list: [
			{
				name: 'E-commerce front-end establishment',
				info: ['Small program development', 'Mall SaaS service', 'Employee management',' Backstage management'],
				img: require("@/assets/productServices/productOperation/innovativeTechnology/pexels-rodrigo-santos-3888149@2x.png")
			},
			{
				name: 'digital marketing',
				info: ['Data Center', 'data cockpit', 'Data Kanban'],
				img: require("@/assets/productServices/productOperation/innovativeTechnology/pexels-photo-5632402@2x.png")
			},
			{
				name: 'Social platform subscription number',
				img: require("@/assets/productServices/productOperation/innovativeTechnology/pexels-andrea-piacquadio-3760069@2x.png")
			},
			{
				name: 'Social platform subscription number',
				img: require("@/assets/productServices/productOperation/innovativeTechnology/pexels-pixabay-267350@2x.png")
			}
		]
	}

}

export default {
  data_CN,
  data_JA,
  data_EN
}


// WEBPACK FOOTER //
// ./src/common/json/productOperation.js